import { render, staticRenderFns } from "./RectangleSelector.vue?vue&type=template&id=ca968dc6"
import script from "./RectangleSelector.vue?vue&type=script&lang=ts"
export * from "./RectangleSelector.vue?vue&type=script&lang=ts"
import style0 from "./RectangleSelector.vue?vue&type=style&index=0&id=ca968dc6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports